import { getConfig } from './config.js';

export function log_error_js(payload, attempt = 1) {
    if (attempt > 5) return;
    if (!getConfig('is_prod')) return;

    try {
        fetch(getConfig('api_url') + '/logging/error_js', {
            method: 'POST',
            headers: {
                'Accept': 'application/json; charset=UTF-8',
                'Content-Type': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify(payload),
        }).then(res => {
            if (res.ok) return;

            // If it's a 502, 503, or 504, it might be worth a retry
            const retryable_errors = [502, 503, 504];
            if (retryable_errors.includes(res.status) && attempt < 5) {
                setTimeout(() => log_error_js(payload, attempt + 1), attempt * 500);
            } else {
                console.warn(`Logging failed with status: ${res.status}. Giving up.`);
            }
        }).catch(() => {
            setTimeout(() => log_error_js(payload, attempt + 1), attempt * 300);
        });
    } catch (e) {
        console.warn('Error logging JS error:', error);
    }
}

export function log_page(payload, attempt= 1) {
    if (attempt > 5) return;

    if (!getConfig('is_prod')) return;

    try {
        fetch(getConfig('api_url') + '/logging/page', {
            method: 'POST',
            headers: {
                'Accept': 'application/json; charset=UTF-8',
                'Content-Type': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify(payload),
        }).then(res => {
            if (res.ok) return; // Success!

            // If it's a 502, 503, or 504, it might be worth a retry
            const retryable_errors = [502, 503, 504];
            if (retryable_errors.includes(res.status) && attempt < 5) {
                setTimeout(() => log_page(payload, attempt + 1), attempt * 500);
            } else {
                console.warn(`Logging failed with status: ${res.status}. Giving up.`);
            }
        }).catch(() => {
            setTimeout(() => log_page(payload, attempt + 1), attempt * 300);
        });
    } catch (error) {
        console.warn('Error logging page:', error);
    }
}
